import styled from "styled-components"
import { PageForm, Container } from "client/components"

const stateColumnWidth = "25%"
const stateColumnMargin = "15px"

export const RequirementLayout = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background: ${(props) => props.theme.pageLayoutBackground};
`
export const RequirementBodyColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - ${stateColumnWidth} - ${stateColumnMargin});
`
export const RequirementForm = styled(PageForm)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const RequirementStateColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: ${stateColumnWidth};
    margin-left: ${stateColumnMargin};
`
export const RequirementStateContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const RequirementParentChildContentWrapper = styled(Container)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
